import {NgModule} from '@angular/core';
import {mapToCanActivate, mapToCanActivateChild, mapToCanDeactivate, RouterModule, Routes} from '@angular/router';
import {TeamDecisionsComponent} from './team-decisions.component';
import {FinancialDecisionComponent} from './financial-decision/financial-decision.component';
import {DiningRoomsDecisionComponent} from './dining-rooms-decision/dining-rooms-decision.component';
import {menuDecisionRoutes} from './menu-decision/menu-decision-routing.module';
import {AreaDecisionComponent} from './area-decision/area-decision.component';
import {periodCompletionRoutes} from './period-completion/period-completion-routing.module';
import {ArchetypeDecisionComponent} from './archetype-decision/archetype-decision.component';
import {PlayerDecisionsClosureComponent} from './player-decisions-closure/player-decisions-closure.component';
import {studiesRoutes} from '../studies/studies.module';
import {CanActivateTeamDecisionsGuard} from './guards/can-activate-team-decisions.guard';
import {
    AnimatorProductsAndChargesDecisionComponent
} from './financial-decision/animator-products-and-charges-decision/animator-products-and-charges-decision.component';
import {
    PlayerFinancialDecisionComponent
} from './financial-decision/player-financial-decision/player-financial-decision.component';
import {CanActivateAnimatorGuard} from './guards/can-activate-animator.guard';
import {InsurancesDecisionComponent} from './financial-decision/insurances-decision/insurances-decision.component';
import {CanDeactivateModificationComponentGuard} from '../guards/can-deactivate-modification-component.guard';
import {staffDecisionRoute} from './staff-decision/staff-decision-route';
import {communicationDecisionRoute} from './communication-decision/communication-decision-route';
import {CanActivateTeamDecisionsHomeGuard} from './guards/can-activate-team-decisions-home-guard';
import {IsNotSimulationOrRevertStartedGuard} from './guards/is-not-simulation-or-revert-started-guard.service';


export const teamDecisionsRoutes: Routes = [
    {
        path: '',
        children: [
            {
                path: '',
                canActivate: mapToCanActivate([CanActivateTeamDecisionsHomeGuard, IsNotSimulationOrRevertStartedGuard]),
                component: TeamDecisionsComponent
            },
            {
                path: 'financial',
                canActivate: mapToCanActivate([CanActivateTeamDecisionsGuard, IsNotSimulationOrRevertStartedGuard]),
                component: FinancialDecisionComponent,
                children: [
                    {
                        path: '',
                        component: PlayerFinancialDecisionComponent,
                        canDeactivate: mapToCanDeactivate([CanDeactivateModificationComponentGuard])
                    },
                    {
                        path: 'animatorProductsAndCharges',
                        component: AnimatorProductsAndChargesDecisionComponent,
                        canActivate: mapToCanActivate([CanActivateAnimatorGuard]),
                        canDeactivate: mapToCanDeactivate([CanDeactivateModificationComponentGuard])
                    },
                    {
                        path: 'insurances',
                        component: InsurancesDecisionComponent,
                        canDeactivate: mapToCanDeactivate([CanDeactivateModificationComponentGuard])
                    }
                ]
            },
            {
                path: 'dining-rooms',
                component: DiningRoomsDecisionComponent,
                canActivate: mapToCanActivate([CanActivateTeamDecisionsGuard, IsNotSimulationOrRevertStartedGuard]),
                canDeactivate: mapToCanDeactivate([CanDeactivateModificationComponentGuard])
            },
            communicationDecisionRoute,
            staffDecisionRoute,
            {
                path: 'menu',
                canActivate: mapToCanActivate([IsNotSimulationOrRevertStartedGuard]),
                canActivateChild: mapToCanActivateChild([CanActivateTeamDecisionsGuard]),
                children: menuDecisionRoutes
            },

            {
                path: 'area',
                canActivate: mapToCanActivate([IsNotSimulationOrRevertStartedGuard]),
                component: AreaDecisionComponent
            },

            {
                path: 'archetypes',
                canActivate: mapToCanActivate([IsNotSimulationOrRevertStartedGuard]),
                component: ArchetypeDecisionComponent
            },

            {
                path: 'period-completion',
                canActivate: mapToCanActivate([IsNotSimulationOrRevertStartedGuard]),
                canActivateChild: mapToCanActivateChild([CanActivateTeamDecisionsGuard]),
                children: periodCompletionRoutes
            },

            {
                path: 'player-decisions-closure',
                canActivate: mapToCanActivate([CanActivateTeamDecisionsGuard, IsNotSimulationOrRevertStartedGuard]),
                component: PlayerDecisionsClosureComponent,
            },

            {
                path: 'studies',
                canActivate: mapToCanActivate([IsNotSimulationOrRevertStartedGuard]),
                canActivateChild: mapToCanActivateChild([CanActivateTeamDecisionsGuard]),
                children: studiesRoutes
            }
        ]
    }
];

@NgModule({
    exports: [RouterModule]
})

export class TeamDecisionsRoutingModule {

}
